firebird.controller('micWebcamOptionsModalCtrl', [
    '$rootScope',
    '$scope',
    '$sce',
    '$timeout',
    '$interval',
    '$window',
    '$q',
    'cookieService',
    'logService',
    'storageService',
    'vertoService',
    'attendeeService',
    'helperService',
    'socketService',
    'analyticsWrapperService',
    'automationService',
    'phoneConferenceService',
    'meetingService',
    'connectivityService',
    'supportLinkService',
    'localStreamManagerService',
    'avDeviceService',
    'avDeviceSettingsService',
    'localizationService',
    'brandingService',
    'virtualBackgroundService',
    'videoFilterService',
    'executionEnvironmentEnum',
    'subscriptionService',
    'userPairStateService',
    'modalHelperService',
    'macSecurityPreferencesService',
    function (
        $rootScope,
        $scope,
        $sce,
        $timeout,
        $interval,
        $window,
        $q,
        cookieService,
        logService,
        storageService,
        vertoService,
        attendeeService,
        helperService,
        socketService,
        analyticsWrapperService,
        automationService,
        phoneConferenceService,
        meetingService,
        connectivityService,
        supportLinkService,
        localStreamManagerService,
        avDeviceService,
        avDeviceSettingsService,
        localizationService,
        brandingService,
        virtualBackgroundService,
        videoFilterService,
        executionEnvironmentEnum,
        subscriptionService,
        userPairStateService,
        modalHelperService,
        macSecurityPreferencesService
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('micWebcamOptionsModalCtrl');

        self.modalState = 'closed';
        self.shouldInitialize = true;
        self.userChangedDeviceSelection = false;

        self.webcamDevices = [];
        self.audioInputDevices = [];
        self.audioOutputDevices = [];
        self.clearDeviceLists = clearDeviceLists;

        self.selectedMicrophone = storageService.get('audio-device');
        self.selectedAudioDevice = storageService.get('audio-device');
        self.selectedVideoDevice = storageService.get('video-device');
        self.selectedAudioOutDevice = storageService.get('audio-output-device');

        self.selectedAudioDeviceOriginalLabel = '';
        self.selectedVideoDeviceOriginalLabel = '';
        self.selectedAudioOutDeviceOriginalLabel = '';

        self.joinAudioMuted =
            storageService.get('joinAudioStatePref') === null ? true : storageService.get('joinAudioStatePref');
        self.shouldHideDefaultMuteOption = shouldHideDefaultMuteOption;

        self.getAudioOnlyStream = getAudioOnlyStream;
        self.getVideoOnlyStream = getVideoOnlyStream;
        self.processVideoOnlyStream = processVideoOnlyStream;
        self.currentVideoOnlyStream = undefined;
        self.currentAudioOnlyStream = undefined;
        self.VDIRef = helperService.getVDIRef();
        self.showTestAudioOutputOption = self.VDIRef.showTestAudioOutputOption;
        self.showAudioInputMicLevelIndicator = self.VDIRef.showAudioInputMicLevelIndicator;
        self.currentSelectedVideoDeviceToggled = false;
        self.isVideoActiveInMeeting = false;
        self.showWebcamPreviewLabel = self.VDIRef.showWebcamPreviewLabel;

        //Labels used for the dropdowns
        self.micLabel = 'Select your Mic';
        self.webcamLabel = 'Select your webcam';
        self.speakerLabel = 'Select your speaker';
        self.resetLabels = resetLabels;

        self.speakerOn = false;
        self.speakerTestSource = $sce.trustAsResourceUrl(
            'https://www.anymeeting.com/webconference/sounds/speaker-test.wav'
        ); // 'Thank you for using AnyMeeting'
        self.micLevel = 0;

        self.phoneNumber = 'Could not retrieve';
        self.accessCode = 'Could not retrieve';
        self.audioPin = 'Could not retrieve';
        self.usePhone = false;
        self.isDedicated = false;

        self.previewError = { mic: false, webcam: false };

        self.showCamera = showCamera;
        self.showMic = showMic;
        self.getDeviceMessage = getDeviceMessage;

        self.hasAvailableWebcam = hasAvailableWebcam;
        self.hasAvailableMic = hasAvailableMic;

        self.getSources = getSources;
        self.gotSourcesFromEnumerate = gotSourcesFromEnumerate;
        self.previewDevice = previewDevice;
        self.applyChanges = applyChanges;
        self.cancelChanges = cancelChanges;
        self.testSpeakers = testSpeakers;
        self.selectTelephoneFromDropDown = selectTelephoneFromDropDown;
        self.useComputerForAudio = useComputerForAudio;
        self.hasWebRTC = helperService.browserHasWebRTC();
        self._preview = preview;
        self.setSelectedDevice = setSelectedDevice;
        self.getPrimaryBtnTitle = getPrimaryBtnTitle;
        self.getSpeakerSelectionTooltip = getSpeakerSelectionTooltip;

        self.selectSpeaker = selectSpeaker;
        self.selectBWSetting = selectBWSetting;
        self.setSelectedBandwidth = setSelectedBandwidth;

        self.showInternationalNumbers = showInternationalNumbers;
        self.hasInternationalCalling = meetingService.hasFeature('internationalCalling');

        self.meetingSettingsModalHeaderBounds = null;
        var scrollClipDebounce = null;

        //event handlers
        self.onShowModal = onShowModal;
        self.reloadDeviceList = reloadDeviceList;
        self.onHideModal = onHideModal;
        self.isInMeeting = false;
        self.getIsInCall = getIsInCall;

        self.joinMeeting = joinMeeting;
        self.setAudioSinkForConference = setAudioSinkForConference;
        self.setAudioSinkForElement = setAudioSinkForElement;

        self.joinVideoConf = joinVideoConf;
        self.joinVideoConfWithoutVideo = joinVideoConfWithoutVideo;
        self.isPromptedBeforeJoiningVideoConf = isPromptedBeforeJoiningVideoConf;

        self.stopActiveStream = stopActiveStream;

        self._handlePermissionError = _handlePermissionError;
        self.isPermissionError = isPermissionError;

        self.init = init;

        self.bandwidthSettings = [];
        self.bwSettingLabel = '';
        self.chosenBWSetting = null;

        self.skipVideoConfPreview = false;
        self.virtualBackgroundInit = false;

        var _AVPermsWarning = {
            show: false,
            showOpenPrefsButton: false,

            hasMicIssue: false,
            hasCamIssue: false,

            iconPath: '',
            header: '',
            bullet1: '',
            bullet2: '',
            bullet3: '',
            supportLink: ''
        };

        self.getAVPermissionWarningHasMicIssue = getAVPermissionWarningHasMicIssue;
        self.getAVPermissionWarningHasCamIssue = getAVPermissionWarningHasCamIssue;
        self.getAVPermissionWarningIconPath = getAVPermissionWarningIconPath;
        self.getAVPermissionWarningHeader = getAVPermissionWarningHeader;
        self.getAVPermissionWarningBullet1 = getAVPermissionWarningBullet1;
        self.getAVPermissionWarningBullet2 = getAVPermissionWarningBullet2;
        self.getAVPermissionWarningBullet3 = getAVPermissionWarningBullet3;
        self.getAVPermissionWarningSupportLink = getAVPermissionWarningSupportLink;
        self.getAVPermissionWarningShow = getAVPermissionWarningShow;
        self.getAVPermissionWarningShowOpenPrefs = getAVPermissionWarningShowOpenPrefs;
        self.attachRedesignDropdownEventListeners = attachRedesignDropdownEventListeners;
        self.onDropdownToggled = onDropdownToggled;
        self.getPreviouslySelectedWebcamStream = getPreviouslySelectedWebcamStream;
        self.isAudioDisconnected = avDeviceService.isAudioDisconnected;
        self.onWindowResize = onWindowResize;

        self.click_AVPermissionWarningOpenSystemPreferences = click_AVPermissionWarningOpenSystemPreferences;
        self.modalsAvailable = false;
        self.rootSubscription = undefined;

        $scope.$on('phone-information', function (e, data) {
            logger.debug('received phone information');

            if (!data || !Object.keys(data).length) {
                return;
            }

            self.phoneNumber = data.phoneNumberFree;
            self.accessCode = attendeeService.getIsPresenter() ? data.presenterPIN : data.attendeePIN;
        });

        //TODO: When Redesign is GA, we need to remove the show/hide event listeners
        $scope.$on('show-modal', onShowModal);
        $scope.$on('device-change-detected', reloadDeviceList);
        $scope.$on('hide-modal', onHideModal);

        $scope.$on('phone-only-state', onPhoneOnlyState);
        $scope.$on('attendee-type-updated', onAttendeeTypeUpdated);
        $scope.$on('phone-state-updated', phoneStateUpdated);

        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);
        $scope.$on('settings-modal-closed', onSettingsModalClosed);

        $scope.$on('meeting-ending', onMeetingEnding);

        $scope.$on('start-virtual-background-stream', onStartVirtualBackgroundStream);
        $scope.$on('stop-virtual-background-stream', onStopVirtualBackgroundStream);

        $scope.$on('virtual-background-stream-started', onVirtualBackgroundStreamStarted);
        $scope.$on('virtual-background-stream-error', onVirtualBackgroundStreamError);
        $window.$(window).on('resize', self.onWindowResize);

        $scope.$on('finished-media-device-selection', onFinishedMediaDeviceSelection);

        init();

        ////////////////////////

        function init() {
            videoFilterService.initVideoFilter();

            var info = phoneConferenceService.getPhoneData();
            if (!info || !Object.keys(info).length) {
                return;
            }
            self.phoneNumber = info.phoneNumberFree || info.phoneNumberToll;
            self.accessCode = attendeeService.getIsPresenter() ? info.presenterPIN : info.attendeePIN;
            self.isDedicated = info.isDedicated;

            self.audioPin = attendeeService.getAudioPin();

            if (helperService.browserHasWebRTC()) {
                automationService.audioState.usePhone = false;
            } else {
                automationService.audioState.usePhone = true;
            }

            setInitialBWSettings();

            if (helperService.getIsRedesign()) {
                //In redesign, this ctrl doesn't get initiated until it first opens,
                //So the normal event listener to detect open/close does not get triggered on first open...
                //So we call onShowModal here (the event listener will call it on subsequent open/close)
                logger.debug('AV Settings ctrl init');
                self.onShowModal({}, 'micWebcamOptions');

                self.shouldInitialize = false;
                self.attachRedesignDropdownEventListeners();
            }

            self.rootSubscription = subscriptionService.createSubscription();
            self.rootSubscription.add(
                userPairStateService.modalsAvailable$.subscribe(next => {
                    self.modalsAvailable = next;
                })
            );
        }

        function setInitialBWSettings() {
            self.bwSettingLabel = localizationService.translate('HEADER.SETTINGS.BANDWIDTH.AUTOMATIC');
            self.bandwidthSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.BANDWIDTH.AUTOMATIC'),
                clear: true
            });
            self.bandwidthSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.BANDWIDTH.HIGHT'),
                setting: {
                    id: 'high-1',
                    standard: 2000000,
                    simulcastTotal: 3000000,
                    simulcast: { high: 2500000, medium: 400000, low: 100000 }
                }
            });
            self.bandwidthSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.BANDWIDTH.MEDIUM'),
                setting: {
                    id: 'med-1',
                    standard: 1000000,
                    simulcastTotal: 1500000,
                    simulcast: { high: 1000000, medium: 400000, low: 100000 }
                }
            });
            self.bandwidthSettings.push({
                label: localizationService.translate('HEADER.SETTINGS.BANDWIDTH.LOW'),
                setting: {
                    id: 'low-1',
                    standard: 500000,
                    simulcastTotal: 750000,
                    simulcast: { high: 425000, medium: 250000, low: 75000 }
                }
            });
        }

        function joinMeeting() {
            $rootScope.$broadcast('virtual-background-selector-apply');
            //determine what state the user is in
            //phone state or computer audio state
            storageService.set('audio-device', self.selectedAudioDevice);
            storageService.set('video-device', self.selectedVideoDevice);
            storageService.set('audio-output-device', self.selectedAudioOutDevice);
            storageService.set('using-phone-for-audio', self.usePhone);
            self.setAudioSinkForConference();

            if (meetingService.getMeetingType() === 'videoconference') {
                self.joinVideoConf();
            } else {
                $rootScope.$broadcast('finished-media-device-selection', {
                    usePhoneForAudio: self.usePhone,
                    joinMeeting: true
                });
            }
        }

        //TODO: REMOVE POST-REDESIGN
        function selectTelephoneFromDropDown() {
            logger.debug('Clicked switch-to-phone - Showing confirmation prompt');

            var swalOpts = {
                title: localizationService.translate('HEADER.DIALOG.SWITCH_TO_PHONE'),
                showCancelButton: true,
                cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                confirmButtonText: localizationService.translate('HEADER.DIALOG.YES_SWITCH_TO_PHONE'),
                closeOnConfirm: true,
                imageUrl: 'img/intermedia/ic_switch_to_phone.png',
                imageSize: '100x100'
            };

            $window.swal(swalOpts, function (switchToPhone) {
                if (switchToPhone) {
                    logger.info('Confirmed switch-to-phone');
                    self.usePhone = true;

                    if (!self.isInMeeting) {
                        self.joinMeeting();
                    } else {
                        self.applyChanges();
                    }

                    self.onHideModal(null, 'micWebcamOptionsModalCtrl');
                } else {
                    logger.info('Cancelled switch-to-phone');
                }
            });
        }

        function useComputerForAudio() {
            self.usePhone = false;
            self.userChangedDeviceSelection = true;

            var previewParams = {
                audio: self.selectedAudioDevice || 'default',
                video: self.selectedVideoDevice || 'default'
            };

            self._preview(previewParams);
        }

        function gotSourcesFromEnumerate(setLabelsDuringEnumeration) {
            self.clearDeviceLists();

            //Prevents generateDeviceObj from retrieving getUserMedia stream for each device
            var noStream = true;

            if (avDeviceService.microphones.length === 0) {
                self.usePhone = true;
            } else {
                avDeviceService.microphones.forEach(function (mediaDeviceInfo, index, array) {
                    avDeviceService
                        .generateDeviceObj(mediaDeviceInfo, index + 1, noStream)
                        .then(function (newDeviceObj) {
                            if (setLabelsDuringEnumeration && newDeviceObj && newDeviceObj.inUse) {
                                self.micLabel = newDeviceObj.fullDisplayName;
                            }

                            self.audioInputDevices.push(newDeviceObj);
                        })
                        .catch(function (err) {
                            logger.error('micWebcamOptions - Unable to generate audio-input device obj:', err);
                        });
                });
            }

            avDeviceService.speakers.forEach(function (mediaDeviceInfo, index, array) {
                avDeviceService
                    .generateDeviceObj(mediaDeviceInfo, index + 1, noStream)
                    .then(function (newDeviceObj) {
                        if (setLabelsDuringEnumeration && newDeviceObj && newDeviceObj.inUse) {
                            self.speakerLabel = newDeviceObj.fullDisplayName;
                        }

                        self.audioOutputDevices.push(newDeviceObj);
                    })
                    .catch(function (err) {
                        logger.error('micWebcamOptions - Unable to generate audio-output device obj:', err);
                    });
            });

            avDeviceService.webcams.forEach(function (mediaDeviceInfo, index, array) {
                avDeviceService
                    .generateDeviceObj(mediaDeviceInfo, index + 1, noStream)
                    .then(function (newDeviceObj) {
                        if (setLabelsDuringEnumeration && newDeviceObj && newDeviceObj.inUse) {
                            self.webcamLabel = newDeviceObj.fullDisplayName;
                        }

                        self.webcamDevices.push(newDeviceObj);
                    })
                    .catch(function (err) {
                        logger.error('micWebcamOptions - Unable to generate video-input device obj:', err);
                    });
            });

            digest();
        }

        function getSources(setLabelsDuringEnumeration) {
            avDeviceService
                .enumerateDevices('mic-webcam-options-preview')
                .then(function () {
                    self.gotSourcesFromEnumerate(setLabelsDuringEnumeration);
                })
                .catch(function (err) {
                    logger.error('getSources', 'Error enumerating devices', err);
                });
        }

        function getDeviceMessage() {
            var retMsg = '';

            if (self.previewError) {
                var supportLink = supportLinkService.getSupportLink('manageDevices');
                var header;
                var bullet;
                var restartMessage = localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.WEBINAR_AV_PERMISSION_WARNING.RESTART_COMPUTER'
                );
                var moreInfoMessage = localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.WEBINAR_AV_PERMISSION_WARNING.MORE_INFO',
                    { supportLink: supportLink }
                );

                if (self.previewError.mic && self.previewError.webcam) {
                    header = localizationService.translate(
                        'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.WEBINAR_AV_PERMISSION_WARNING.CHROME_MIC_CAM.HEADER'
                    );
                    bullet = localizationService.translate(
                        'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.WEBINAR_AV_PERMISSION_WARNING.CHROME_MIC_CAM.BULLET'
                    );
                } else if (self.previewError.webcam && !self.previewError.mic) {
                    header = localizationService.translate(
                        'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.WEBINAR_AV_PERMISSION_WARNING.CHROME_CAM.HEADER'
                    );
                    bullet = localizationService.translate(
                        'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.WEBINAR_AV_PERMISSION_WARNING.CHROME_CAM.BULLET'
                    );
                } else if (self.previewError.mic && !self.previewError.webcam) {
                    header = localizationService.translate(
                        'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.WEBINAR_AV_PERMISSION_WARNING.CHROME_MIC.HEADER'
                    );
                    bullet = localizationService.translate(
                        'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.WEBINAR_AV_PERMISSION_WARNING.CHROME_MIC.BULLET'
                    );
                }

                if (header) {
                    retMsg = header + ' ' + bullet + ' ' + restartMessage + ' ' + moreInfoMessage;
                }
            }
            return retMsg;
        }

        function showCamera() {
            if (self.previewError && self.previewError.webcam) {
                return false;
            }

            return true;
        }

        function showMic() {
            if (self.previewError && self.previewError.mic) {
                return false;
            }

            return true;
        }

        function previewDevice(source, type) {
            if (self.hasWebRTC) {
                var deviceId = source.deviceInfo.deviceId;
                var deviceLabel = source.fullDisplayName;

                // Ignore device change if device is already selected by returning
                if (
                    ((type === 'audioinput' || type === 'audio') && self.selectedAudioDevice === deviceId) ||
                    ((type === 'videoinput' || type === 'video') && self.selectedVideoDevice === deviceId) ||
                    (type === 'audiooutput' && self.selectedAudioOutDevice === deviceId)
                ) {
                    return;
                }

                if (
                    self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix &&
                    !attendeeService.getIsVideoMuted() &&
                    (type === 'videoinput' || type === 'video')
                ) {
                    self.currentSelectedVideoDeviceToggled = true;
                }

                logger.debug('MicWebcam Preview - Previewing ' + type + 'device id: ' + deviceId);

                self.userChangedDeviceSelection = true;
                self.setSelectedDevice(type, deviceId, deviceLabel, source.deviceInfo.originalLabel);

                var previewParams = {};
                previewParams[type] = deviceId;
                if (type === 'videoinput' || type === 'video') {
                    // When user selects a new device from dropdown to view the preview, it results in blank/black
                    // screen with Citrix SDK. In order to handle this we remove the existing video element from
                    // the DOM, create a new one and then attach stream to it.
                    helperService.removePreviewVideoElement();
                    $timeout(
                        () => {
                            helperService.createPreviewVideoElement();
                        },
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ? 200 : 0
                    );
                }
                self._preview(previewParams);
            }
        }

        function setSelectedDevice(type, deviceId, label, sourceOriginalLabel) {
            if (type === 'audioinput' || type === 'audio') {
                self.micLabel = label;
                self.selectedAudioDevice = deviceId;
                self.selectedAudioDeviceOriginalLabel = sourceOriginalLabel;
                self.selectedMicrophone = deviceId;
            } else if (type === 'videoinput' || type === 'video') {
                self.selectedVideoDevice = deviceId;
                self.selectedVideoDeviceOriginalLabel = sourceOriginalLabel;
                self.webcamLabel = label;

                socketService.send({
                    message: 'switched-webcam',
                    data: {}
                });

                analyticsWrapperService.eventTrack('Meeting - Options - Switched Webcam', {
                    category: 'Mic and webcam options'
                });
            } else if (type === 'audiooutput') {
                self.selectedAudioOutDevice = deviceId;
                self.selectedAudioOutDeviceOriginalLabel = sourceOriginalLabel;
                self.speakerLabel = label;

                analyticsWrapperService.eventTrack('Meeting - Options - Switched speaker', {
                    category: 'Mic and webcam options'
                });
            }
        }

        function getAVPermissionWarningHasMicIssue() {
            return _AVPermsWarning.hasMicIssue;
        }
        function getAVPermissionWarningHasCamIssue() {
            return _AVPermsWarning.hasCamIssue;
        }

        function getAVPermissionWarningIconPath() {
            return _AVPermsWarning.iconPath;
        }

        function getAVPermissionWarningHeader() {
            return _AVPermsWarning.header;
        }

        function getAVPermissionWarningBullet1() {
            return _AVPermsWarning.bullet1;
        }

        function getAVPermissionWarningBullet2() {
            return _AVPermsWarning.bullet2;
        }

        function getAVPermissionWarningBullet3() {
            return _AVPermsWarning.bullet3;
        }

        function getAVPermissionWarningSupportLink() {
            return _AVPermsWarning.supportLink;
        }

        function getAVPermissionWarningShow() {
            return _AVPermsWarning.show;
        }

        function getAVPermissionWarningShowOpenPrefs() {
            return _AVPermsWarning.showOpenPrefsButton;
        }

        function click_AVPermissionWarningOpenSystemPreferences() {
            if (self.getAVPermissionWarningHasMicIssue()) {
                macSecurityPreferencesService.openMicrophone();
            } else if (self.getAVPermissionWarningHasCamIssue()) {
                macSecurityPreferencesService.openCamera();
            }
        }

        function preview(previewParams, initialPreview) {
            //example previewParams:
            // {
            //     audio: [audio source id],
            //     video: [video source id]
            // }

            logger.debug('MicWebcam Preview - Starting preview');

            var deferred = $q.defer();

            //Stop specific stream (audio or video) depending on params
            self.stopActiveStream(previewParams);

            //Retrieve list of available devices
            var setLabelsDuringEnumeration = initialPreview ? true : false;
            self.getSources(setLabelsDuringEnumeration);

            var audioOnlyConstraints, videoOnlyConstraints;

            if (previewParams.audio) {
                audioOnlyConstraints = avDeviceService.generateConstraints('audio', previewParams.audio);
            }

            if (previewParams.video) {
                videoOnlyConstraints = avDeviceService.generateConstraints('video', previewParams.video);
            }

            if (
                (!audioOnlyConstraints || !audioOnlyConstraints.audio) &&
                (!videoOnlyConstraints || !videoOnlyConstraints.video)
            ) {
                self.previewError = { mic: true, webcam: true };
                deferred.reject('Constraints not provided for getUserMedia');
                return deferred.promise;
            }

            //Need to run two separate getUserMedia request for audio and video
            //So that one device failure doesn't prevent the other from previewing

            var streamErrors = {};

            self.getAudioOnlyStream(audioOnlyConstraints)
                .catch(function (audioOnlyStreamError) {
                    streamErrors.audio = audioOnlyStreamError;
                })
                .then(function () {
                    return self.getVideoOnlyStream(videoOnlyConstraints);
                })
                .catch(function (videoOnlyStreamError) {
                    streamErrors.video = videoOnlyStreamError;
                })
                .finally(function () {
                    if (
                        !streamErrors.audio &&
                        !streamErrors.video &&
                        avDeviceService.getDevicePermissions().audioAllowed &&
                        avDeviceService.getDevicePermissions().videoAllowed
                    ) {
                        logger.log('canceling webrtc permission overlay in micWebcamOptions - permission allowed');
                        $rootScope.$broadcast('new-explicit-permission-granted');

                        deferred.resolve('MicWebcam Preview - WebRTC Permissions Granted');
                    } else {
                        if (helperService.isOSXCatalina() && helperService.isElectron()) {
                            var catalinaPerms = avDeviceService.getMacOSSystemPermissions();

                            if (catalinaPerms.audioAllowed === false && catalinaPerms.videoAllowed === false) {
                                // show OSX Catalina warning div for mic and webcam
                                _AVPermsWarning.hasMicIssue = true;
                                _AVPermsWarning.hasCamIssue = true;

                                _AVPermsWarning.iconPath = '/img/redesign/icons/red-circle-exclamation.svg';

                                // set header
                                _AVPermsWarning.header = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_MIC_CAM.HEADER'
                                );

                                // set bullets
                                _AVPermsWarning.bullet1 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_MIC_CAM.BULLET_1'
                                );
                                _AVPermsWarning.bullet2 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_MIC_CAM.BULLET_2'
                                );
                                _AVPermsWarning.bullet3 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.COMMON.RELOAD_APPLICATION'
                                );
                            } else if (catalinaPerms.audioAllowed === false) {
                                // show OSX Catalina warning div for mic
                                _AVPermsWarning.hasMicIssue = true;

                                // set icon
                                _AVPermsWarning.iconPath = '/img/redesign/icons/red-no-mic';

                                // set header
                                _AVPermsWarning.header = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_MIC.HEADER'
                                );

                                // set bullets
                                _AVPermsWarning.bullet1 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_MIC.BULLET_1'
                                );
                                _AVPermsWarning.bullet2 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_MIC.BULLET_2'
                                );
                                _AVPermsWarning.bullet3 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.COMMON.RELOAD_APPLICATION'
                                );
                            } else if (catalinaPerms.videoAllowed === false) {
                                // show OSX Catalina warning div for webcam
                                _AVPermsWarning.hasCamIssue = true;

                                // set icon
                                _AVPermsWarning.iconPath = '/img/redesign/icons/red-no-cam';

                                // set header
                                _AVPermsWarning.header = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_CAM.HEADER'
                                );

                                // set bullets
                                _AVPermsWarning.bullet1 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_CAM.BULLET_1'
                                );
                                _AVPermsWarning.bullet2 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CATALINA_CAM.BULLET_2'
                                );
                                _AVPermsWarning.bullet3 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.COMMON.RELOAD_APPLICATION'
                                );
                            }

                            if (catalinaPerms.audioAllowed === false || catalinaPerms.videoAllowed === false) {
                                // show Catalina open system preferences button
                                _AVPermsWarning.showOpenPrefsButton = true;

                                // set support link to Catalina help
                                _AVPermsWarning.supportLink = supportLinkService.getSupportLink('catalinaScreenShare');

                                // show Catalina warning div
                                _AVPermsWarning.show = true;
                            }
                        } else if (helperService.isChrome()) {
                            var chromeAudioPermIssue = false;
                            var chromeVideoPermIssue = false;

                            if (
                                streamErrors.audio &&
                                streamErrors.audio.message &&
                                streamErrors.audio.message.indexOf('Permission denied') > -1
                            ) {
                                chromeAudioPermIssue = true;
                            }

                            if (
                                streamErrors.video &&
                                streamErrors.video.message &&
                                streamErrors.video.message.indexOf('Permission denied') > -1
                            ) {
                                chromeVideoPermIssue = true;
                            }

                            if (chromeAudioPermIssue === true && chromeVideoPermIssue === true) {
                                // show Chrome warning div for mic and webcam
                                _AVPermsWarning.hasMicIssue = true;
                                _AVPermsWarning.hasCamIssue = true;

                                // set icon
                                _AVPermsWarning.iconPath = '/img/redesign/icons/red-circle-exclamation.svg';

                                // set header
                                _AVPermsWarning.header = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_MIC_CAM.HEADER'
                                );

                                // set bullets
                                _AVPermsWarning.bullet1 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_MIC_CAM.BULLET_1'
                                );
                                _AVPermsWarning.bullet2 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_MIC_CAM.BULLET_2'
                                );
                                _AVPermsWarning.bullet3 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.COMMON.RELOAD_THE_WEB_PAGE'
                                );
                            } else if (chromeAudioPermIssue === true) {
                                // show Chrome warning div for mic
                                _AVPermsWarning.hasMicIssue = true;

                                // set icon
                                _AVPermsWarning.iconPath = '/img/redesign/icons/red-no-mic.svg';

                                // set header
                                _AVPermsWarning.header = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_MIC.HEADER'
                                );

                                // set bullets
                                _AVPermsWarning.bullet1 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_MIC.BULLET_1'
                                );
                                _AVPermsWarning.bullet2 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_MIC.BULLET_2'
                                );
                                _AVPermsWarning.bullet3 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.COMMON.RELOAD_THE_WEB_PAGE'
                                );
                            } else if (chromeVideoPermIssue === true) {
                                // show Chrome warning div for webcam
                                _AVPermsWarning.hasCamIssue = true;

                                // set icon
                                _AVPermsWarning.iconPath = '/img/redesign/icons/red-no-cam.svg';

                                // set header
                                _AVPermsWarning.header = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_CAM.HEADER'
                                );

                                // set bullets
                                _AVPermsWarning.bullet1 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_CAM.BULLET_1'
                                );
                                _AVPermsWarning.bullet2 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.AV_PERMISSION_WARNING.CHROME_CAM.BULLET_2'
                                );
                                _AVPermsWarning.bullet3 = localizationService.translate(
                                    'DEVICE_SELECTION_PREVIEW.PERMISSION_ERRORS.COMMON.RELOAD_THE_WEB_PAGE'
                                );
                            }

                            if (chromeAudioPermIssue === true || chromeVideoPermIssue === true) {
                                // hide Catalina open system preferences button
                                _AVPermsWarning.showOpenPrefsButton = false;

                                // set support link to Catalina help
                                _AVPermsWarning.supportLink = supportLinkService.getSupportLink('allowMicChrome');

                                // show Chrome warning div
                                _AVPermsWarning.show = true;
                            }
                        } else {
                            // hide warning div
                            _AVPermsWarning.show = false;
                        }

                        if (self.isPermissionError(streamErrors.audio) && self.isPermissionError(streamErrors.video)) {
                            //This is to maintain the original flow of having both permissions denied...
                            //We should eventually handle cases with one blocked + one allowed device
                            self._handlePermissionError();
                            deferred.reject('MicWebcam Preview - WebRTC Permissions Denied');
                        } else {
                            //We used to call _handleDeviceError if not a permission error...
                            //In this case, we'd retry calling _preview() to be able to get an audio or video specific stream,
                            //But since we're now doing that be default, we don't really need _handleDeviceError anymore
                            deferred.reject('MicWebcam Preview - getUserMedia device error');
                        }
                    }
                });

            return deferred.promise;
        }

        function getAudioOnlyStream(audioOnlyConstraints) {
            var deferred = $q.defer();

            if (self.usePhone) {
                //Skip audio stream retrieval
                deferred.resolve();
                return deferred.promise;
            }

            if (avDeviceService.isAudioDeviceBlocked()) {
                self.previewError.mic = true;
                deferred.reject({ message: 'Permission denied' });
            }
            if (audioOnlyConstraints && audioOnlyConstraints.audio) {
                logger.debug('MicWebcam Preview - Retrieving audio-only stream', audioOnlyConstraints);

                avDeviceService
                    .getStream(audioOnlyConstraints)
                    .then(function (audioOnlyStream) {
                        logger.info('MicWebcam Preview - Successully retrieved audio-only stream');
                        self.previewError.mic = false;
                        self.currentAudioOnlyStream = audioOnlyStream;

                        avDeviceService.stopMicLevelTrackingForPreview();
                        avDeviceService.trackMicLevelForPreview(audioOnlyStream, function (newMicLevel) {
                            self.micLevel = newMicLevel;
                            digest();
                        });

                        deferred.resolve();
                    })
                    .catch(function (audioOnlyStreamRetrievalError) {
                        logger.error(
                            'MicWebcam Preview - Error retrieving audio-only stream',
                            audioOnlyStreamRetrievalError
                        );
                        self.previewError.mic = true;
                        deferred.reject(audioOnlyStreamRetrievalError);
                    });
            } else {
                //Skip audio stream retrieval
                deferred.resolve();
            }

            return deferred.promise;
        }

        function getVideoOnlyStream(videoOnlyConstraints) {
            var deferred = $q.defer();

            if (avDeviceService.isVideoDeviceBlocked()) {
                self.previewError.webcam = true;
                deferred.reject({ message: 'Permission denied' });
            } else if (videoOnlyConstraints && videoOnlyConstraints.video) {
                logger.debug('MicWebcam Preview - Retrieving video-only stream', videoOnlyConstraints);

                self.isVideoActiveInMeeting =
                    self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix &&
                    attendeeService.getIsVideoActive() &&
                    self.selectedVideoDevice === storageService.get('video-device') &&
                    localStreamManagerService.getCurrentWebcamStreamForVDI();
                if (self.isVideoActiveInMeeting) {
                    // VDI - Show published active video stream in preview instead of calling getUserMedia.
                    self.currentVideoOnlyStream = localStreamManagerService.getCurrentWebcamStreamForVDI();
                    const videoElement = $window.$('#video-only-container > #video-preview')[0];
                    if (videoElement) {
                        if ($window.Janus?.attachMediaStream) {
                            $window.Janus.attachMediaStream(videoElement, self.currentVideoOnlyStream);
                        } else {
                            videoElement.srcObject = self.currentVideoOnlyStream;
                        }
                    }
                } else {
                    avDeviceService
                        .getStream(videoOnlyConstraints)
                        .then(function (videoOnlyStream) {
                            logger.info('MicWebcam Preview - Successully retrieved video-only stream');
                            self.currentVideoOnlyStream = videoOnlyStream;
                            processVideoOnlyStream(videoOnlyConstraints);
                            deferred.resolve();
                        })
                        .catch(function (videoOnlyStreamRetrievalError) {
                            logger.error(
                                'MicWebcam Preview - Error retrieving video-only stream',
                                videoOnlyStreamRetrievalError
                            );
                            self.previewError.webcam = true;
                            deferred.reject(videoOnlyStreamRetrievalError);
                        });
                }
            } else {
                //Skip video stream retrieval
                deferred.resolve();
            }

            return deferred.promise;
        }

        function processVideoOnlyStream(videoOnlyConstraints) {
            self.previewError.webcam = false;
            $timeout(() => {
                const videoElement = $window.$('#video-only-container > #video-preview')[0];
                if (videoElement) {
                    if ($window.Janus?.attachMediaStream) {
                        $window.Janus.attachMediaStream(videoElement, self.currentVideoOnlyStream);
                    } else {
                        videoElement.srcObject = self.currentVideoOnlyStream;
                    }
                }
            }, 800);
            if (self.VDIRef.getVdiType() !== executionEnvironmentEnum.Citrix) {
                if (
                    !meetingService.isWebinar() &&
                    videoFilterService.getActiveFeedStream() &&
                    storageService.get('video-device') == videoOnlyConstraints.video.deviceId.exact
                ) {
                    // Stop original stream before reassigning to prevent leak
                    logger.info('MicWebcam Preview - Replacing with active feed stream, stopping original');
                    if (self.currentVideoOnlyStream && self.currentVideoOnlyStream.getTracks) {
                        self.currentVideoOnlyStream.getTracks().forEach(function (track) {
                            track.stop();
                        });
                    }
                    self.currentVideoOnlyStream = videoFilterService.getActiveFeedStream();
                } else if (
                    meetingService.getIsWebinarVirtualBlurredBackgroundAvailable() ||
                    virtualBackgroundService.hasVirtualBackground()
                ) {
                    var filter = {};
                    filter.deviceId = videoOnlyConstraints.video.deviceId.exact;
                    filter.value = virtualBackgroundService.getVirtualBackground() || 'none';
                    virtualBackgroundService.requestFilteredBackgroundStream(filter, 'video-audio-setting');
                    self.virtualBackgroundInit = true;
                }
            }
        }

        function isPermissionError(err) {
            var isPermErr = false;

            if (err && err.name) {
                if (
                    err.name === 'SecurityError' ||
                    err.name === 'NotAllowedError' ||
                    err.name === 'PermissionDeniedError'
                ) {
                    isPermErr = true;
                }
            }

            return isPermErr;
        }

        function _handlePermissionError() {
            logger.debug('calling _handlePermissionError ...');

            $('#micWebcamOptions').modal('hide');

            if (!self.getIsInCall()) {
                logger.info('canceling webrtc permission overlay in micWebcamOptions - permission denied');

                //TODO: probably change this for options specific to dialog
                $rootScope.$broadcast('new-explicit-permission-denied');
                $rootScope.$broadcast('finished-media-device-selection', {
                    usePhoneForAudio: self.usePhone
                });
            } else {
                if (helperService.getIsRedesign() === true) {
                    var closeButtonHtmlBlocked =
                        '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                    $window.swal({
                        title:
                            closeButtonHtmlBlocked +
                            localizationService.translate('SCREENSHARE.DIALOG.MIC_AND_WEBCAM_BLOCKED'),
                        text: localizationService.translate(
                            'SCREENSHARE.DIALOG.MIC_AND_WEBCAM_BLOCKED_ALLOW_ACCESS_AND_REFRESH',
                            { link: supportLinkService.getSupportLink('allowMicChrome') }
                        ),
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: localizationService.translate('COMMON.CLOSE_TEXT'),
                        allowOutsideClick: true,
                        html: true,
                        imageUrl: 'img/redesign/modal/pop-up-pic-error.svg'
                    });
                } else {
                    //TODO: REMOVE POST-REDESIGN
                    $window.swal({
                        title: 'Mic and webcam are blocked',
                        text: 'Audio and video options are unavailable. Please allow mic and webcam and refresh your browser',
                        type: 'warning',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: 'Okay',
                        allowOutsideClick: true
                    });
                }
            }

            digest();
        }

        function setAudioSinkForConference() {
            if (!self.usePhone) {
                self.setAudioSinkForElement('videoFeed', self.selectedAudioOutDevice);
            }
        }

        function cancelChanges() {
            $rootScope.$broadcast('virtual-background-selector-cancel');
        }

        // noSave=true is needed only for VDI because it cannot save more than one webcam, but need preview with changed.
        function applyChanges(noSave) {
            if (self.selectedAudioDevice !== 'telephone') {
                self.selectedMicrophone = self.selectedAudioDevice;
            }

            var previousVideoDevice = storageService.get('video-device');
            var previousAudioDevice = storageService.get('audio-device');
            var previousAudioOutputDevice = storageService.get('audio-output-device');

            storageService.set('using-phone-for-audio', self.usePhone);
            storageService.set('joinAudioStatePref', self.joinAudioMuted);

            var videoInputChanged =
                self.currentSelectedVideoDeviceToggled || previousVideoDevice !== self.selectedVideoDevice;

            var audioInputChanged = previousAudioDevice !== self.selectedAudioDevice;
            var audioOutputChanged = previousAudioOutputDevice !== self.selectedAudioOutDevice;

            if (meetingService.getIsSfuEnabled()) {
                avDeviceService.setDeviceErrors({ camError: false, micError: false });

                if (audioInputChanged && !!self.selectedAudioDevice) {
                    avDeviceSettingsService.setExplicitlyChosenAudioIn(
                        self.selectedAudioDevice,
                        self.selectedAudioDeviceOriginalLabel
                    );
                }

                if (videoInputChanged && !noSave) {
                    avDeviceSettingsService.setExplicitlyChosenVideo(
                        self.selectedVideoDevice,
                        self.selectedVideoDeviceOriginalLabel
                    );
                }

                if (audioOutputChanged) {
                    avDeviceSettingsService.setExplicitlyChosenAudioOut(
                        self.selectedAudioOutDevice,
                        self.selectedAudioOutDeviceOriginalLabel
                    );
                }
            } else {
                // For non-SFU mode, save device selections to storage directly
                if (audioInputChanged && !!self.selectedAudioDevice) {
                    storageService.set('audio-device', self.selectedAudioDevice);
                }

                if (audioOutputChanged) {
                    storageService.set('audio-output-device', self.selectedAudioOutDevice);
                }

                if (videoInputChanged && !noSave) {
                    storageService.set('video-device', self.selectedVideoDevice);
                }
            }

            // Newer Chrome & Electron versions can replace video tracks without hanging up.
            // Setting a new input source should be only used for Verto calls (Webinars).
            if (!localStreamManagerService.shouldUseDeprecatedSpecForStreams() && !meetingService.getIsSfuEnabled()) {
                if (audioInputChanged) {
                    vertoService.setNewAudioInputSource(self.selectedAudioDevice, self.currentAudioOnlyStream);
                }

                if (videoInputChanged) {
                    if (noSave) {
                        var previousWebcamStream = self.getPreviouslySelectedWebcamStream(previousVideoDevice);
                        vertoService.setNewVideoInputSource(previousVideoDevice, previousWebcamStream);
                    } else {
                        vertoService.setNewVideoInputSource(self.selectedVideoDevice, self.currentVideoOnlyStream);
                    }
                }
            }

            if (audioOutputChanged) {
                vertoService.setNewAudioOutputSource(self.selectedAudioOutDevice);
            }

            if (meetingService.getIsSfuEnabled()) {
                var previousBandwidth = storageService.get('sfu-bandwidth');
                var previousParsed = null;
                if (previousBandwidth) {
                    try {
                        previousParsed = JSON.parse(previousBandwidth);
                    } catch (e) {} // stored setting can be treated like null here ... it's about to get overwritten anyways
                }

                if (!self.chosenBWSetting) {
                    if (previousParsed) {
                        videoInputChanged = true;
                    }
                    storageService.remove('sfu-bandwidth');
                } else {
                    if (!previousParsed || previousParsed.id !== self.chosenBWSetting.setting.id) {
                        videoInputChanged = true;
                    }
                    storageService.set('sfu-bandwidth', JSON.stringify(self.chosenBWSetting.setting));
                }
            }

            //this essentially means this options dialog has applied changes
            $rootScope.$broadcast('finished-media-device-selection', {
                usePhoneForAudio: self.usePhone,
                newVideoInputDeviceSelected: videoInputChanged,
                newAudioInputDeviceSelected: audioInputChanged,
                newAudioOutputDeviceSelected: audioOutputChanged
            });

            $rootScope.$broadcast('virtual-background-selector-apply');
        }

        function testSpeakers() {
            if (self.speakerOn) {
                // If the audio file is playing,
                // return and do not try to play it again
                // on top of itself
                return;
            }

            self.speakerOn = true;

            // Let the speakerOn variable be set to true
            // for 2 seconds, then set it to false so the user
            $timeout(function () {
                self.speakerOn = false;
            }, 2000); // 2 seconds
        }

        //this is only stopping the preview stream ... so we leave this in this modal dialog
        function stopActiveStream(streamTypes) {
            if (!streamTypes) {
                return;
            }

            if (streamTypes.audio && self.currentAudioOnlyStream) {
                logger.info('MicWebcam Preview - Stopping audio-only stream');

                if (self.currentAudioOnlyStream.stop) {
                    self.currentAudioOnlyStream.stop();
                }

                if (self.currentAudioOnlyStream.getTracks) {
                    self.currentAudioOnlyStream.getTracks().forEach(function (track) {
                        track.stop();
                    });
                }

                self.currentAudioOnlyStream = undefined;
            }

            if (streamTypes.video && self.currentVideoOnlyStream) {
                logger.info('MicWebcam Preview - Stopping video-only stream');

                if (videoFilterService.getActiveFeedStream()) {
                    logger.info("video-audio-setting - don't stop stream because it is being used");
                } else {
                    if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                        // Citrix VDI SDK v4 - Remove the published active video stream from preview to avoid getBoundingClientRect issue.
                        logger.log('MicWebcam Preview - Stopping video-only stream for VDI');
                        const videoPreviewElement = $window.$('#video-only-container > #video-preview')[0];
                        if (videoPreviewElement) {
                            logger.log('stopActiveStream', 'Clearing srcObject for video preview element');
                            videoPreviewElement.srcObject = null;
                        } else {
                            logger.warn('stopActiveStream', 'Video preview element not found during VDI cleanup');
                        }
                    }
                    // On VDI, we show the active video stream in the settings modal preview.
                    // Hence if the video stream is still active in the meeting, the stream need not be stopped.
                    if (!self.isVideoActiveInMeeting) {
                        if (self.currentVideoOnlyStream.stop) {
                            self.currentVideoOnlyStream.stop();
                        }

                        if (self.currentVideoOnlyStream.getTracks) {
                            self.currentVideoOnlyStream.getTracks().forEach(function (track) {
                                track.stop();
                            });
                        }
                    }
                }

                self.currentVideoOnlyStream = undefined;
                virtualBackgroundService.stopFilteredBackgroundStream('video-audio-setting');
            }
        }

        function setAudioSinkForElement(elementId, sinkId) {
            var element = $window.angular.element($window.document.querySelector('#' + elementId));
            if (element && element[0] && typeof element[0].sinkId !== 'undefined') {
                element[0].setSinkId(sinkId);
            }
        }

        function setSelectedBandwidth(setting) {
            if (!meetingService.getIsSfuEnabled()) {
                return;
            }

            var storageItem = storageService.get('sfu-bandwidth');
            if (storageItem) {
                storageItem = JSON.parse(storageItem);
                switch (storageItem.id) {
                    case 'high-1':
                        self.bwSettingLabel = self.bandwidthSettings[1].label;
                        break;
                    case 'med-1':
                        self.bwSettingLabel = self.bandwidthSettings[2].label;
                        break;
                    case 'low-1':
                        self.bwSettingLabel = self.bandwidthSettings[3].label;
                        break;
                    default:
                        break;
                }
            } else {
                self.bwSettingLabel = self.bandwidthSettings[0].label;
            }
        }
        function reloadDeviceList(e) {
            if (self.modalState === 'open') {
                self.onShowModal(e, 'micWebcamOptions', true);
            }
        }

        function onShowModal(e, modalName, notCreateVideoElement) {
            if (modalName === 'micWebcamOptions') {
                $rootScope.$broadcast('virtual-background-selector-init');
                if (!self.VDIRef.showContentsOnTopOfVideo) {
                    $rootScope.$broadcast('vdi-toggle-annotation-ui', true);
                }

                self.currentSelectedVideoDeviceToggled = false;
                self.userChangedDeviceSelection = false;
                avDeviceService.startDevicePermissionsFlow({ avSettingsModal: true }).finally(function () {
                    if (!notCreateVideoElement) {
                        $timeout(
                            () => {
                                helperService.createPreviewVideoElement();
                            },
                            self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ? 500 : 0
                        );
                    }

                    self.selectedAudioDevice = storageService.get('audio-device');
                    self.selectedVideoDevice = storageService.get('video-device');
                    self.selectedAudioOutDevice = storageService.get('audio-output-device');
                    self.usePhone = connectivityService.getAudioThroughPhone();

                    self.resetLabels();

                    self.setAudioSinkForElement('speaker-test', self.selectedAudioOutDevice);

                    self.isInMeeting = self.getIsInCall();

                    var previewParams = {
                        audio: self.selectedAudioDevice || 'default',
                        video: self.selectedVideoDevice || 'default'
                    };

                    self.setSelectedBandwidth();

                    var initialPreview = true;
                    self._preview(previewParams, initialPreview)
                        .then(function (res) {
                            logger.info(res);
                        })
                        .catch(function (err) {
                            logger.error(err);
                        })
                        .finally(function () {
                            self.modalState = 'open';
                        });

                    if (self.VDIRef.allowClipOperationsOnVideoPreview) {
                        $window.angular
                            .element($window.document.querySelector('#micWebcamOptions'))
                            .bind('scroll', handleScrolling);
                        $window.angular
                            .element($window.document.querySelector('#micWebcamOptionsModalContent'))
                            .bind('scroll', handleScrolling);
                        $window.angular
                            .element($window.document.querySelector('#meetingSettings'))
                            .bind('scroll', handleScrolling);
                    }

                    if (helperService.isMobile()) {
                        $window.$('#videoFeed').hide();
                        helperService.delayedWebRTCRefresh();
                    }

                    digest();
                });
            }
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('micWebcamOptionsModalCtrl') !== -1) {
                self.modalState = 'closed';
                self.userChangedDeviceSelection = false;
                if (!self.VDIRef.showContentsOnTopOfVideo) {
                    $rootScope.$broadcast('vdi-toggle-annotation-ui', false);
                }

                self.isInMeeting = self.getIsInCall();

                self.stopActiveStream({ audio: true, video: true });
                // First stop the active stream, then remove the preview video element
                helperService.removePreviewVideoElement();

                avDeviceService.stopMicLevelTrackingForPreview();

                if (helperService.isMobile()) {
                    $window.$('#videoFeed').show();
                    helperService.delayedWebRTCRefresh();
                }

                self.selectedAudioDevice = storageService.get('audio-device');
                self.selectedVideoDevice = storageService.get('video-device');
                self.selectedAudioOutDevice = storageService.get('audio-output-device');
                self.usePhone = storageService.get('using-phone-for-audio');

                self.clearDeviceLists();
                self.resetLabels();
                self.setSelectedBandwidth();

                if (self.meetingSettingsModalHeaderBounds) {
                    self.VDIRef.removeClipRect(self.meetingSettingsModalHeaderBounds);
                    self.meetingSettingsModalHeaderBounds = null;
                }
                // Otherwise a scroll right before close can still fire its debounced callback after the
                // modal/preview elements are gone, re-adding a clip rect that never gets removed.
                $timeout.cancel(scrollClipDebounce);

                digest();
            }
        }

        function onPhoneOnlyState(e, data) {
            self.usePhone = true;
            digest();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function showInternationalNumbers() {
            if (self.modalsAvailable) {
                modalHelperService.openInternationalNumbersModal(helperService.getLocationHost());
            } else {
                $rootScope.$broadcast('show-modal', 'internationalNumbers');
            }
        }

        function selectBWSetting(setting) {
            self.userChangedDeviceSelection = true;

            if (setting.clear) {
                self.chosenBWSetting = null;
                self.bwSettingLabel = self.bandwidthSettings[0].label;
                return;
            }

            self.chosenBWSetting = setting;
            switch (setting.setting.id) {
                case 'high-1':
                    self.bwSettingLabel = self.bandwidthSettings[1].label;
                    break;
                case 'med-1':
                    self.bwSettingLabel = self.bandwidthSettings[2].label;
                    break;
                case 'low-1':
                    self.bwSettingLabel = self.bandwidthSettings[3].label;
                    break;
                default:
                    break;
            }
        }

        function selectSpeaker(source) {
            self.userChangedDeviceSelection = true;
            self.setAudioSinkForElement('speaker-test', source.deviceInfo.deviceId);

            self.selectedAudioOutDevice = source.deviceInfo.deviceId;
            self.speakerLabel = source.fullDisplayName;
            self.selectedAudioOutDeviceOriginalLabel = source.deviceInfo.originalLabel;

            analyticsWrapperService.eventTrack('Meeting - Options - Switched speaker', {
                category: 'Mic and webcam options'
            });
        }

        function onAttendeeTypeUpdated(e, data) {
            var info = phoneConferenceService.getPhoneData();
            self.accessCode = attendeeService.getIsPresenter() ? info.presenterPIN : info.attendeePIN;
            digest();
        }

        function shouldHideDefaultMuteOption() {
            return meetingService.isWebinar() || attendeeService.getIsHost();
        }

        function joinVideoConf() {
            var existingSkipPreviewPreference = cookieService.get('skipVideoConfPreview');

            if (self.skipVideoConfPreview !== existingSkipPreviewPreference) {
                cookieService.put('skipVideoConfPreview', self.skipVideoConfPreview, {
                    secure: true,
                    samesite: 'strict'
                });
            }

            // Override with query string
            if (helperService.getQueryParameter('audio') === 'computer') {
                $rootScope.$broadcast('new-user-audio-choice', 'audio');
            } else if (helperService.getQueryParameter('audio') === 'phone') {
                $rootScope.$broadcast('new-user-audio-choice', 'phone');
            } else {
                $rootScope.$broadcast('new-user-audio-choice', 'no-audio');
            }
        }

        function joinVideoConfWithoutVideo() {
            logger.info('Joining without webcam');
            $rootScope.$broadcast('virtual-background-selector-cancel');
            avDeviceService.setShouldIgnoreCamera(true);
            attendeeService.setIsVideoMuted(true);
            self.joinVideoConf();
        }

        function isPromptedBeforeJoiningVideoConf() {
            return meetingService.getMeetingType() === 'videoconference' && !self.getIsInCall();
        }

        function phoneStateUpdated() {
            self.usePhone = connectivityService.getAudioThroughPhone();
            digest();
        }

        function hasAvailableWebcam() {
            return self.webcamDevices && self.webcamDevices.length > 0 ? true : false;
        }

        function hasAvailableMic() {
            return self.audioInputDevices && self.audioInputDevices.length > 0 ? true : false;
        }

        function getPrimaryBtnTitle() {
            if (!self.hasAvailableWebcam() && !self.hasAvailableMic()) {
                //If no available devices, clicking the 'Update Settings' modal button
                //Will enable switched-to-phone
                return localizationService.translate('SETTINGS.SWITCH_TO_PHONE');
            }

            return localizationService.translate('SETTINGS.UPDATE_SETTINGS');
        }

        function resetLabels() {
            self.micLabel = localizationService.translate('DEVICE_SELECTION_PREVIEW.SELECT_YOUR_MICROPHONE');
            self.webcamLabel = localizationService.translate('DEVICE_SELECTION_PREVIEW.SELECT_YOUR_WEBCAM');
            self.speakerLabel = localizationService.translate('DEVICE_SELECTION_PREVIEW.SELECT_YOUR_SPEAKER');
        }

        function getSpeakerSelectionTooltip() {
            if (self.VDIRef.getVdiType() !== executionEnvironmentEnum.Azure) {
                return '';
            }

            return localizationService.translate('DEVICE_SELECTION_PREVIEW.AZURE_VDI_SPEAKER_SELECTION_LIMITED');
        }

        function clearDeviceLists() {
            self.webcamDevices = [];
            self.audioInputDevices = [];
            self.audioOutputDevices = [];
            digest();
        }

        function getIsInCall() {
            if (meetingService.getIsSfuEnabled()) {
                var state = connectivityService.getLocalConnectivityState();
                if (state === 'connecting' || state === 'connected') {
                    return true;
                }
                return false;
            }

            return vertoService.isInCall();
        }

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'av-settings';

                if (data.openedTab === tabName) {
                    logger.debug('AV Settings Tab opened');

                    if (self.shouldInitialize) {
                        self.shouldInitialize = false;
                        //AV Settings Tab opened for the first time since opening Meeting Settings modal
                        self.onShowModal({}, 'micWebcamOptions');
                    }

                    if (virtualBackgroundService.hasVirtualBackground() && self.virtualBackgroundInit) {
                        var filter = {};
                        filter.deviceId = self.selectedVideoDevice;
                        filter.value = virtualBackgroundService.getVirtualBackground() || 'none';
                        virtualBackgroundService.requestFilteredBackgroundStream(filter, 'video-audio-setting');
                    }
                } else if (data.closedTab === tabName) {
                    logger.debug('AV Settings Tab closed');
                    virtualBackgroundService.stopFilteredBackgroundStream('video-audio-setting');
                }
            }
        }

        function onSettingsModalClosed(e, data) {
            if (self.currentSelectedVideoDeviceToggled || (data && data.applyChanges)) {
                logger.info('AV Settings - applying changes');
                // VDI - SDK cannot capture more than one stream at a time.
                // We need to handle situations when webcam1 stream is active in meeting and webcam2 preview is selected in the settings modal.
                // In such cases, we need to restart the active stream in the meeting. Hence need to pass parameters to applyChanges().
                if (!self.VDIRef.showMultipleVideoStreams && !(data && data.applyChanges)) {
                    self.applyChanges(true);
                } else {
                    self.applyChanges();
                }
            } else {
                logger.info('AV Settings - closing without applying changes');
            }

            self.shouldInitialize = true;
            self.virtualBackgroundInit = false;
            virtualBackgroundService.stopFilteredBackgroundStream('video-audio-setting');
            self.onHideModal({}, 'micWebcamOptionsModalCtrl');
        }

        function onMeetingEnding() {
            //Clean up audio/video streams
            if (self.modalState === 'open') {
                self.onHideModal({}, 'micWebcamOptionsModalCtrl');
            }
        }

        function getVideoFilterMediaConstraints() {
            return avDeviceService.generateConstraints('video', self.selectedVideoDevice || 'default', 'video-filter');
        }

        function onStartVirtualBackgroundStream(ev, data) {
            videoFilterService.onStartVirtualBackgroundStream(data, getVideoFilterMediaConstraints);
        }

        function onStopVirtualBackgroundStream(ev, data) {
            videoFilterService.onStopVirtualBackgroundStream(data);
        }

        function onVirtualBackgroundStreamStarted(ev, data) {
            if (data.identifier == 'video-audio-setting') {
                if (
                    self.currentVideoOnlyStream &&
                    self.currentVideoOnlyStream.getTracks &&
                    self.currentVideoOnlyStream !== data.stream
                ) {
                    logger.info('onVirtualBackgroundStreamStarted', 'stopping previous currentVideoOnlyStream tracks');
                    [...self.currentVideoOnlyStream.getTracks()].forEach(track => {
                        try {
                            track.stop();
                        } catch (e) {}
                    });
                }

                self.currentVideoOnlyStream = data.stream;
                var videoElement = $window.$('#video-only-container > #video-preview')[0];
                if (videoElement) {
                    if ($window.Janus?.attachMediaStream) {
                        $window.Janus.attachMediaStream(videoElement, self.currentVideoOnlyStream);
                    } else {
                        videoElement.srcObject = self.currentVideoOnlyStream;
                    }
                }
            }
        }

        function onVirtualBackgroundStreamError(ev, data) {
            if (data && data.identifier == 'video-audio-setting') {
                if (data.error) {
                    self.previewError.webcam = true;
                }
            }
        }

        function attachRedesignDropdownEventListeners() {
            if (helperService.getIsRedesign()) {
                logger.debug('Attaching redesign dropdown listeners');

                $window.$('.webcam-dropdown-container').on('show.bs.dropdown', function () {
                    self.onDropdownToggled('show');
                });

                $window.$('.webcam-dropdown-container').on('hide.bs.dropdown', function () {
                    self.onDropdownToggled('hide');
                });
            }
        }

        function onDropdownToggled(dropdownState) {
            if (self.VDIRef.allowClipOperationsOnVideoPreview) {
                const videoPreviewElementContainer = $window.$('#video-only-container')[0];
                const videoPreviewElement = $window.$('#video-preview')[0];
                // Both can be gone by the time this fires (e.g. modal/preview already torn down before
                // Bootstrap's dropdown hide event reaches here) - nothing to toggle in that case.
                if (!videoPreviewElementContainer || !videoPreviewElement) {
                    return;
                }
                //If dropdown is open, header auto-hide should be disabled
                if (dropdownState === 'show') {
                    videoPreviewElementContainer.style.minWidth = videoPreviewElementContainer.clientWidth + 'px';
                    videoPreviewElementContainer.style.minHeight = videoPreviewElementContainer.clientHeight + 'px';
                    videoPreviewElement.style.display = 'none';
                } else if (dropdownState === 'hide') {
                    videoPreviewElement.style.display = 'inline-block';
                    handleScrolling();
                } else {
                    logger.warn('Unsupported dropdownState:', dropdownState);
                }
            }
        }

        function onFinishedMediaDeviceSelection(e, data) {
            // Sync modal device selections when user accepts the explicit device prompt
            // (e.g., when newly connected devices are detected and user clicks "Yes" to switch)
            // Only proceed if: modal is open, user hasn't manually changed devices, and event is from explicit prompt
            if (
                self.modalState !== 'open' ||
                self.userChangedDeviceSelection ||
                !(data && data.fromExplicitDevicePrompt)
            ) {
                logger.debug(
                    'onFinishedMediaDeviceSelection',
                    `Skipping device sync - modalState: ${self.modalState}, userChanged: ${
                        self.userChangedDeviceSelection
                    }, fromExplicitPrompt: ${data && data.fromExplicitDevicePrompt}`
                );
                return;
            }

            // Retrieve current device selections from storage (already updated by avDeviceService)
            var newAudioDevice = storageService.get('audio-device');
            var newVideoDevice = storageService.get('video-device');
            var newAudioOutDevice = storageService.get('audio-output-device');

            // Detect which devices changed
            var audioDeviceChanged = self.selectedAudioDevice !== newAudioDevice;
            var videoDeviceChanged = self.selectedVideoDevice !== newVideoDevice;
            var audioOutDeviceChanged = self.selectedAudioOutDevice !== newAudioOutDevice;

            if (!audioDeviceChanged && !videoDeviceChanged && !audioOutDeviceChanged) {
                logger.debug('onFinishedMediaDeviceSelection', 'No device changes detected, skipping sync');
                return;
            }

            logger.info(
                'onFinishedMediaDeviceSelection',
                `Syncing modal with explicitly chosen devices - audio: ${audioDeviceChanged}, video: ${videoDeviceChanged}, speaker: ${audioOutDeviceChanged}`
            );

            // Update modal's internal device selections to match storage
            self.selectedAudioDevice = newAudioDevice;
            self.selectedVideoDevice = newVideoDevice;
            self.selectedAudioOutDevice = newAudioOutDevice;

            // Refresh device lists and update labels
            self.getSources(true);

            // Update preview streams for changed devices
            var previewParams = {};
            if (audioDeviceChanged) {
                previewParams.audio = newAudioDevice;
            }
            if (videoDeviceChanged) {
                previewParams.video = newVideoDevice;
            }

            if (Object.keys(previewParams).length > 0) {
                self._preview(previewParams)
                    .then(function () {
                        logger.info('onFinishedMediaDeviceSelection', 'Successfully updated preview with new devices');
                    })
                    .catch(function (err) {
                        logger.error('onFinishedMediaDeviceSelection', 'Error updating preview:', err);
                    });
            }

            digest();
        }

        function getPreviouslySelectedWebcamStream(deviceId) {
            // VDI - SDK cannot capture more than one stream at a time.
            // We need to handle situations when webcam1 stream is active in meeting and webcam2 preview is selected in the settings modal.
            // The function gets the stream of the active webcam to be restarted when settings modal changes are not saved.
            var previewParams = {};
            previewParams[type] = deviceId;
            var videoOnlyConstraints = avDeviceService.generateConstraints('video', previewParams.video);
            avDeviceService
                .getStream(videoOnlyConstraints)
                .then(function (videoOnlyStream) {
                    logger.info('MicWebcam Preview applyChanges - Successully retrieved video-only stream');
                    deferred.resolve();
                })
                .catch(function (videoOnlyStreamRetrievalError) {
                    logger.error(
                        'MicWebcam Preview applyChanges - Error retrieving video-only stream',
                        videoOnlyStreamRetrievalError
                    );
                    deferred.reject(videoOnlyStreamRetrievalError);
                });
            return deferred.promise;
        }

        function handleScrolling() {
            var headerElement = $window.$('#meetingSettingsModalHeader')[0];
            var videoPreview = $window.$('#video-preview')[0];
            if (!headerElement || !videoPreview) {
                return;
            }
            // Scroll fires many times per gesture - without cancelling the previous wait, multiple
            // in-flight callbacks could race each other reading/writing self.meetingSettingsModalHeaderBounds
            // and leave a clip rect that doesn't match the latest scroll position.
            $timeout.cancel(scrollClipDebounce);
            scrollClipDebounce = $timeout(function () {
                syncMeetingSettingsModalHeaderClipRect(headerElement, videoPreview);
            }, 10);
        }

        // Clips exactly the overlap between the (sticky) settings-modal header and the video preview - the
        // previous elementsOverlap() only compared one edge of each rect (video top vs. header bottom), so
        // it still reported "overlapping" after the preview had scrolled fully out of view above the header,
        // and it never cleared the clip rect once they stopped overlapping, leaving a stale/misaligned clip
        // rect behind. Always resyncs to the current, real intersection (or clears it if there is none).
        function syncMeetingSettingsModalHeaderClipRect(headerElement, videoPreview) {
            if (self.meetingSettingsModalHeaderBounds) {
                self.VDIRef.removeClipRect(self.meetingSettingsModalHeaderBounds);
                self.meetingSettingsModalHeaderBounds = null;
            }

            var overlap = intersectRects(headerElement.getBoundingClientRect(), videoPreview.getBoundingClientRect());
            if (!overlap) {
                return;
            }

            var newBounds = new DOMRect();
            newBounds.x = overlap.left;
            newBounds.y = overlap.top;
            newBounds.width = overlap.right - overlap.left;
            newBounds.height = overlap.bottom - overlap.top;
            self.VDIRef.addClipRect(newBounds);
            self.meetingSettingsModalHeaderBounds = newBounds;
        }

        // Null if the two rects don't actually overlap.
        function intersectRects(a, b) {
            var left = Math.max(a.left, b.left);
            var top = Math.max(a.top, b.top);
            var right = Math.min(a.right, b.right);
            var bottom = Math.min(a.bottom, b.bottom);
            if (right <= left || bottom <= top) {
                return null;
            }
            return { left: left, top: top, right: right, bottom: bottom };
        }

        function onWindowResize() {
            if (self.VDIRef.allowClipOperationsOnVideoPreview) {
                handleScrolling();
            }
        }
    }
]);
